/**
 * Normalize HTML list structure by removing blank lines between list items
 * 
 * This utility ensures:
 * 1. No blank lines between <li> items
 * 2. List items are consecutive
 * 3. No <p> tags wrapping <li> items
 * 4. No <br> tags around list items
 * 
 * @param {string} htmlContent - The HTML content to normalize
 * @returns {string} - Normalized HTML with clean list structure
 */
export function normalizeListSpacing(htmlContent) {
  if (!htmlContent) return htmlContent;

  let normalized = htmlContent;

  // STEP 1: Remove <p> tags that wrap <li> items
  // Pattern: <p><li>...</li></p> → <li>...</li>
  normalized = normalized?.replace(/<p>\s*(<li[^>]*>.*?<\/li>)\s*<\/p>/gis, '$1');

  // STEP 2: Remove <br> tags immediately before or after <li> tags
  // Pattern: <br><li> or </li><br> → clean <li> or </li>
  normalized = normalized?.replace(/<br\s*\/?>\s*(<li[^>]*>)/gi, '$1');
  normalized = normalized?.replace(/(<\/li>)\s*<br\s*\/?>/gi, '$1');

  // STEP 3: Remove excessive whitespace between list items
  // Pattern: </li>\n\n\n<li> → </li>\n<li>
  normalized = normalized?.replace(/(<\/li>)\s*\n\s*\n+\s*(<li[^>]*>)/gi, '$1\n$2');

  // STEP 4: Clean up whitespace inside <ul> and <ol> tags
  // Pattern: <ul>\n\n\n<li> → <ul>\n<li>
  normalized = normalized?.replace(/(<ul[^>]*>)\s*\n\s*\n+\s*/gi, '$1\n');
  normalized = normalized?.replace(/(<ol[^>]*>)\s*\n\s*\n+\s*/gi, '$1\n');

  // STEP 5: Remove whitespace before closing </ul> and </ol>
  // Pattern: </li>\n\n\n</ul> → </li>\n</ul>
  normalized = normalized?.replace(/\s*\n\s*\n+\s*(<\/ul>)/gi, '\n$1');
  normalized = normalized?.replace(/\s*\n\s*\n+\s*(<\/ol>)/gi, '\n$1');

  // STEP 6: Convert "telegraphic-style" lists (each item with blank line) to clean consecutive lists
  // Pattern: Multiple <ul> blocks → Single consolidated <ul>
  normalized = normalized?.replace(/(<\/ul>)\s*\n\s*\n+\s*(<ul[^>]*>)/gi, '\n');
  normalized = normalized?.replace(/(<\/ol>)\s*\n\s*\n+\s*(<ol[^>]*>)/gi, '\n');

  return normalized;
}

export default {
  normalizeListSpacing
};